/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const NotePlusIcon = createIcon({
    displayName: 'NotePlusIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M16 4.78v4.726l-.855-.252a14.771 14.771 0 0 0-4.182-.584c-.058 0-.116.002-.173.004a2.526 2.526 0 0 1-.123.004v7.986c0 2.142-1.193 3.336-3.334 3.336C5.193 20 4 18.806 4 16.665c0-2.142 1.193-3.336 3.333-3.336.806 0 1.476.17 2 .494V4.065l.629-.036c.33-.019.662-.029 1-.029a16.1 16.1 0 0 1 4.56.639l.478.14ZM5.333 16.664c0 1.403.598 2.002 2 2.002 1.402 0 2-.599 2-2.002 0-1.402-.598-2-2-2-1.402 0-2 .598-2 2Zm5.63-9.329c1.277 0 2.52.14 3.704.414V5.787a15.093 15.093 0 0 0-4-.45v2.001c.098-.002.197-.003.296-.003ZM17.167 13v2.834H20v1.332h-2.834V20h-1.332v-2.834H13v-1.332h2.834V13h1.332Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "m19 9.254-1.283-.379C15.747 8.295 13.636 8 11.444 8a5.48 5.48 0 0 0-.258.007 8.723 8.723 0 0 1-.186.006V18c0 3.21-1.79 5-5 5s-5-1.79-5-5 1.79-5 5-5c1.208 0 2.214.254 3 .74V1.099l.942-.054c.495-.028.995-.044 1.502-.044 2.383 0 4.684.322 6.84.958L19 2.17v7.085ZM3 18c0 2.103.897 3 3 3 2.103 0 3-.897 3-3 0-2.103-.897-3-3-3-2.103 0-3 .897-3 3ZM17 3.678a22.657 22.657 0 0 0-6-.674v3a24.61 24.61 0 0 1 6 .616V3.678ZM19 16h4v2h-4v4h-2v-4h-4v-2h4v-4h2v4Z",
            clipRule: "evenodd"
        })
    ]
});
NotePlusIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'NotePlusIcon'
};
export { NotePlusIcon };

//# sourceMappingURL=note-plus.js.map